<template>
  <div>
    <!-- 遮罩 -->
    <div class="zhezhao" v-if="isLogin || isRegister"></div>
    <!-- 登陆注册 -->
    <div v-if="isLogin || isRegister" style="background:#eeeeee" class="box">
      <div>
        <img @click="closeModal" class="tc-on shut" src="/static/img/qiye/chahao.png" alt />
      </div>
      <div class="box-title" style="background:#3a3959;">
        <p style="position:relative;">
          <img style="width:150px;" src="/static/img/header-logo.png" alt /><span v-if="version">{{ version }}</span>
        </p>
      </div>
      <div>
        <img style="display:block;width:100%;height:100%;" src="/static/img/colordiv.png" alt />
      </div>
      <!-- 登陆 -->
      <div v-if="isLogin" class="login-mess">
        <ul class="login-nav">
          <li :class="active=='pass'?'active':''" @click="changeState('pass')">
            <span>密码登录</span>
          </li>
          <li :class="active=='mess'?'active':''" @click="changeState('mess')">
            <span>短信登录</span>
          </li>
          <li :class="active=='qrcode'?'active':''" @click="changeState('qrcode')">
            <span>扫码登录</span>
          </li>
          <!-- <li :class="active=='qywx'?'active':''" @click="changeState('qywx')">
            <span>企业微信</span>
          </li> -->
          <div style="clear:both;"></div>
        </ul>
        <div v-if="active=='pass'" class="log-by-pass">
          <p>
            <input
              key="pass-phone"
              type="text"
              id="phone"
              @keyup.enter="onSignin()"
              v-model="signin.username"
              placeholder="手机号/邮箱"
            />
          </p>
          <p>
            <input
              key="pass-pass"
              type="password"
              id="password"
              @keyup.enter="onSignin()"
              v-model="signin.password"
              placeholder="密码"
            />
          </p>
          <p>
            <button class="login-btn" @click="onSignin()">登&emsp;录</button>
          </p>
        </div>
        <div v-if="active=='mess'" class="log-by-mess">
          <p>
            <input
              key="mess-phone"
              class="vcode"
              type="text"
              v-model="signin.mobile"
              @keyup.enter="onSignin()"
              placeholder="请输入手机号"
            />

            <el-select style="width: 31%; height: 35px; text-align: left;" v-model="signin.countryCode">
              <el-option
                v-for="item in areaCode"
                :key="item.text"
                :label="item.value"
                :value="item.value">
                <span style="float: left">{{ item.text }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
              </el-option>
            </el-select>

          </p>
          <p>
            <input
              key="mess-code"
              class="vcode"
              type="text"
              @keyup.enter="onSignin()"
              v-model="signin.validCode"
              placeholder="验证码"
            />
            <button class="vcode-btn" @click="getSiginValidCode()" ref="signinVcodeBtn">获取验证码</button>
          </p>
          <p>
            <button class="login-btn" @click="onSignin()">登&emsp;录</button>
          </p>
        </div>
        <div v-if="active=='qrcode'" class="log-by-qywx">
          <qrcode-login @login="redirectApp"></qrcode-login>
        </div>
        <div v-if="active=='qywx'" class="log-by-qywx">
          <qywx-login @login="redirectApp" @register="checkRegister"></qywx-login>
        </div>
        <div class="login-bottom">
          <div v-if="active=='qrcode'" style="flex:1">打开<a href="https://saas-help.usoftchina.com/doc/app/download" target="_blank">华商云服APP</a>扫一扫</div>
          <div v-if="active=='qywx'" style="flex:1">打开企业微信扫一扫</div>
          <a v-if="active=='pass'" :href="$url.accountCenter + '/resetPassword'" target="_blank"
           class="clickbtn">忘记密码?&ensp;</a>
          <span v-if="active=='pass'">|</span>
          <span @click="checkRegister" class="clickbtn">&ensp;免费注册</span>
        </div>
      </div>
      <!-- 注册 -->
      <div v-if="isRegister" class="reg-mess">
        <ul class="cloud-kind">
          <li :class="kindActive=='trade'?'kind-active':''" @click="changeKindState('trade')">
            <img src="/static/img/trade.svg" alt />
            <span>贸易云</span>
          </li>
          <li :class="kindActive=='make'?'kind-active':''" @click="changeKindState('make')">
            <img src="/static/img/make.svg" alt />
            <span>制造云</span>
          </li>
          <div style="clear:both;"></div>
        </ul>
        <p class="area">
          <label class="field-label" for="area">地&emsp;&emsp;区</label>
          <span class="area-box" id="area">
            <el-radio v-model="area" label="10" border class="area-item" size="medium">中国大陆</el-radio>
            <el-radio v-model="area" label="20" border class="area-item" size="medium">其他地区</el-radio>
          </span>
        </p>
        <p v-if="!loginStatus">
          <label class="field-label" for="name">姓&emsp;&emsp;名</label>
          <input type="text" id="name" v-model="signup.userName" placeholder="请输入您的真实姓名" />
        </p>
        <p v-if="!loginStatus">
          <label class="field-label" for="phone">手&emsp;&emsp;机</label>
          <input class="vcode" type="text" id="phone" v-model="signup.mobile" placeholder="请输入您的手机号码" />

          <el-select class="area-select" v-model="signin.countryCode" :disabled="area == 10">
            <el-option
              v-for="item in areaCode"
              :key="item.text"
              :label="item.value"
              :value="item.value">
              <span style="float: left">{{ item.text }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
            </el-option>
          </el-select>

        </p>
        <p v-if="loginStatus">
          <label class="field-label" for="name">姓&emsp;&emsp;名</label>
          <input ref="name" type="text" id="name" v-model="signup.userName" placeholder="请输入您的真实姓名" />
        </p>
        <p v-if="loginStatus">
          <label class="field-label" for="phone">手&emsp;&emsp;机</label>
          <input class="vcode" ref="phone" type="text" id="phone" v-model="signup.mobile" placeholder="请输入您的手机号码" />

          <el-select class="area-select" v-model="signin.countryCode" :disabled="area == 10">
            <el-option
              v-for="item in areaCode"
              :key="item.text"
              :label="item.value"
              :value="item.value">
              <span style="float: left">{{ item.text }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
            </el-option>
          </el-select>

        </p>
        <p>
          <label class="field-label" for="vcode">验&ensp;证&ensp;码</label>
          <input
            class="vcode"
            type="text"
            id="vcode"
            v-model="signup.validCode"
            placeholder="请输入获得的验证码"
          />
          <button class="vcode-btn" @click="getSigupValidCode()" ref="signupVcodeBtn">获取验证码</button>
        </p>
        <p v-if="area == 10">
          <label class="field-label" for="company">企业名称</label>
          <search-box id="company" style="width: 75%;" :readonly="!allowEditCompanyName" 
            v-model="signup.companyName" @select="onCompanySelect($event)"/>
        </p>
        <p v-if="area == 10">
          <label class="field-label"></label>
          <input type="text" readonly v-model="signup.businessCode" placeholder="统一社会信用代码" />
        </p>
        <p v-if="area == 20">
          <label class="field-label">企业名称</label>
          <input type="text" v-model="signup.companyName" placeholder="企业名称" />
        </p>
        <p v-if="area == 20">
          <label class="field-label"></label>
          <input type="text" v-model="signup.businessCode" placeholder="统一社会信用代码" />
        </p>
        <p v-if="signup.inviteCode">
          <label class="field-label" for="company">专属顾问</label>
          <input type="text" id="inviteCode" readonly="readonly" v-model="partner.name" />
        </p>
        <p class="notice">
          <span style="margin-left:23%;color:red;">*</span>注册即是表示同意
          <a href="https://saas-help.usoftchina.com/doc/base/service_protocol" target="_blank">《华商云服平台服务条款》</a>
        </p>
        <p class="juzhong">
          <button class="confirm" @click="onSignup()">注&emsp;册</button>
        </p>
        <p v-if="!loginStatus" class="checklogin juzhong">
          已有账号?
          <span @click="checkLogin">立即登录</span>
        </p>
        <!-- <div class="wx-register">
          <div class="wx-btn" @click="qywxRegister()">
            <span class="saas sa-qiyeweixin"></span>企业微信注册
          </div>
        </div> -->
      </div>
    </div>
    <!-- 企业微信注册 -->
    <div v-if="isWxRegister" style="background:#fff" class="box">
      <div style="position:relative">
        <span class="saas sa-chahao" @click="closeWxWin"></span>
      </div>
      <div class="wx-mess">
        <p class="wx-text">企业微信注册</p>
        <div class="imgbox">
          <div class="imgcontent">
            <img v-if="kindActive === 'make'" src="/static/img/make-app.png" alt />
            <img v-else-if="kindActive === 'trade'" src="/static/img/trade-app.png" alt />
          </div>
        </div>
        <p style="margin-top:20px;">请使用企业微信扫描二维码注册{{kindActive == "make"?"制造云":'贸易云'}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Session from "@/utils/session";
import qywxLogin from "@/components/qywx/login.vue";
import QrcodeLogin from "@/components/qrcode/login.vue";
import SearchBox from "@/components/conenter/SearchBox.vue";
import areaCode from "../../../static/js/areaCode";
const env = process.env.NODE_ENV;
areaCode.reverse().forEach(e => e.value = '+' + e.value)

export default {
  components: {
    qywxLogin,
    QrcodeLogin,
    SearchBox
  },
  data() {
    return {
      area: "10",
      active: "pass",
      pass: "pass",
      mess: "mess",
      isWxRegister: false,
      signupCodeSend: false,
      areaCode,
      /**
       * 登录信息
       */
      signin: {
        username: "",
        password: "",
        mobile: "",
        countryCode: '+86',
        validCode: ""
      },
      /**
       * 注册信息
       */
      signup: {
        companyName: "",
        businessCode: "",
        userName: "",
        mobile: "",
        validCode: "",
        inviteCode: ""
      },
      version: env == 'development' || env == 'testing' ? '测试版' : null,
      partner: { name: null },

      mytoken: Session.get() //本地储存的用户信息
    };
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
    isRegister() {
      return this.$store.state.isRegister;
    },
    loginStatus() {
      return this.$store.state.loginStatus;
    },
    kindActive() {
      //控制注册弹窗的tab
      return this.$store.state.kindTab;
    },
    allowEditCompanyName() {
      var mobile, code = this.signup.validCode;
      if (!this.loginStatus) {
        mobile = this.signup.mobile;
      } else if (this.loginStatus && this.$refs.phone) {
        mobile = this.$refs.phone.value;
      }
      return this.signupCodeSend && mobile && code && code.length == 6;
    }
  },
  updated() {
    if (this.$refs.name || this.$refs.phone) {
      this.$refs.name.value = this.$store.state.name;
      this.$refs.phone.value = this.$store.state.mobile;
    }
  },
  watch: {
    isLogin(is) {
      if (is) {
        // 从邀请链接过来
        let inviteCode = this.$route.query.code;
        if (inviteCode) { 
          this.getPartnerInfo(inviteCode);
        }
      }
    },
    isRegister(is) {
      if (is) {
        // 从邀请链接过来
        let inviteCode = this.$route.query.code;
        if (inviteCode) { 
          this.getPartnerInfo(inviteCode);
        }
      }
    },
    area(value) {
      if(value == 10) {
        this.signin.countryCode = '+86'
      }
    }
  },
  methods: {
    // 关闭窗口
    closeModal() {
      const me = this;
      me.$store.commit("clickregisterfalse");
      me.$store.commit("clickloginfalse");
    },
    //切换登录方式
    changeState(type) {
      this.active = type;
    },
    //切换系统
    changeKindState(type) {
      this.$store.commit("setKindTab", type);
    },
    //切换登录注册
    checkLogin() {
      this.$store.commit("clicklogintrue");
      this.$store.commit("clickregisterfalse");

      this.signin.countryCode = '+86'
    },
    checkRegister() {
      this.$store.commit("clickloginfalse");
      this.$store.commit("clickregistertrue");

      this.signin.countryCode = '+86'
    },
    qywxRegister() {
      this.closeModal();
      this.isWxRegister = true;
    },
    closeWxWin(){
      this.checkRegister();
      this.isWxRegister = false;
    },
    /**
     * 获取登录验证码
     */
    getSiginValidCode() {
      if (!this.signin.mobile) {
        this.$message.error("请输入手机号");
      } else {
        const reg = new RegExp("^\\d{8,11}$");
        if (!reg.test(this.signin.mobile)) {
          this.$message.error("请输入正确手机号");
        } else {
          this.$captcha.show();
          this.$bus.$on('getTicket', res => {
            if (res.ret === 0) {
              this.$ajax({
                url: this.$url.api + "/api/auth/authorize/vcode",
                method: "post",
                params: {
                  mobile: this.signin.mobile,
                  countryCode: this.signin.countryCode.replace('+', ''),
                  ticket: res.ticket,
                  appId: res.appid,
                  randstr: res.randstr
                }
              }).then(res => {
                if (!res.data.success) {
                  this.$message.error(res.data.message);
                } else {
                  this.$message.success("发送成功");
                  this.lockBtn("signinVcodeBtn");
                }
              });
            } else {
              this.$message.error('未通过验证');
            }
            this.$bus.$off('getTicket')
          })
        }
      }
    },
    /**
     * 登录
     */
    onSignin() {
      if (this.active == "pass") {
        if (!this.signin.username) {
          this.$message.error("请输入手机号/邮箱");
        } else if (!this.signin.password) {
          this.$message.error("请输入密码");
        } else {
          this.doAuth({
            username: this.signin.username,
            password: this.signin.password
          });
        }
      } else {
        if (!this.signin.mobile) {
          this.$message.error("请输入手机号");
        } else if (!this.signin.validCode) {
          this.$message.error("请输入验证码");
        } else {
          this.doAuth({
            mobile: this.signin.mobile,
            validCode: this.signin.validCode
          });
        }
      }
    },
    /**
     * 登录获取授权
     */
    doAuth(params) {
      this.$store.state.isloading = true;
      this.$ajax({
        url: this.$url.api + "/api/auth/authorize",
        method: "post",
        params: params
      }).then(res => {
        this.$store.state.isloading = false;
        if (res.data.success) {
          // 带有合伙人邀请码
          let authInfo = res.data.data,
              inviteCode = this.$route.query.code;
          this.setSession(authInfo);
          if (inviteCode) {
            this.checkPartnerStatus(inviteCode, authInfo);
          } else {
            this.redirectApp(authInfo);
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    /**
     * 检查绑定顾问的状态
     */
    checkPartnerStatus(inviteCode, authInfo) {
      const me = this, token = Session.getToken();
      me.$ajax({
        url: me.$url.api + "/api/account/partner/customer/status",
        params: {
          inviteCode
        },
        headers: {
          Authorization: token
        }
      }).then(res => {
        let resp = res.data, data = resp.data;
        if (resp.success) {
          if (data.hasPartner) {
            let partner = data.customer.partner;
            me.$alert(`您已经绑定了顾问 ${partner.name}(${partner.inviteCode})`, '警告', {
              confirmButtonText: '知道了',
              type: 'warning',
              callback: function() {
                me.redirectApp(authInfo);
              }
            });
          } else if (data.inviter) {
            this.$confirm(`${data.inviter.name}(${data.inviter.inviteCode}) 将成为您的专属顾问`, '提示', {
              confirmButtonText: '同意',
              cancelButtonText: '不同意',
              type: 'warning'
            }).then(() => {
              me.bindPartner(inviteCode, authInfo);
            }).catch(() => {
              me.redirectApp(authInfo);
            });
          } else {
            me.redirectApp(authInfo);
          }
        } else {
          me.$message.error(res.data.message);
        }
      });
    },
    /**
     * 绑定顾问
     */
    bindPartner(inviteCode, authInfo) {
      const token = Session.getToken();
      this.$ajax({
        url: this.$url.api + "/api/account/partner/customer/open",
        method: 'post',
        params: {
          inviteCode
        },
        headers: {
          Authorization: token
        }
      }).then(res => {
        let resp = res.data, data = resp.data;
        if (resp.success) {
          if (!data.hasPartner) {
            me.$alert('绑定顾问失败', '出错了', {
              confirmButtonText: '知道了',
              type: 'warning',
              callback: function() {
                me.redirectApp(authInfo);
              }
            });
          } else {
            me.$alert(`${data.inviter.name} 是您的专属顾问了`, '提示', {
              confirmButtonText: '知道了',
              type: 'success',
              callback: function() {
                me.redirectApp(authInfo);
              }
            });
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    setSession(authInfo) {
      let session = authInfo.token,
        account = authInfo.account;
      account.companies = account.companies || [];
      session.account = account;
      Session.set(session);
    },
    /**
     * 跳转具体应用页面
     */
    redirectApp(authInfo) {
      this.$store.commit("clickregisterfalse");
      this.$store.commit("clickloginfalse");
      const me = this;
      me.setSession(authInfo);
      if (!authInfo.companyId) {
        // 添加企业
        me.$router.push({ path: "/tradecloud" });
        me.$store.commit("Logintrue");
        me.$store.commit("setCompanyIdNone");
        this.$router.go(0);
      } else {
        // 跳转应用页面
        let company = authInfo.account.defaultCompany, 
          url = me.$url.web[company.dcName || 'default'][authInfo.appId || 'trade-app'], 
          sameOrigin = url.indexOf(window.location.origin) == 0,
          route = me.$route.query.portal || (company.b2b ? 'supplier' : 'main');
        if (!sameOrigin) {
          // 跨域直接传token
          url += '/#authorize/' + Session.get().token;
        } else {
          url += '/#' + route;
        }
        window.location.href = url;
      }
    },
    /**
     * 获取注册验证码
     */
    getSigupValidCode() {
      var phone;
      if (!this.loginStatus) {
        phone = this.signup.mobile;
      } else if (this.loginStatus) {
        phone = this.$refs.phone.value;
      }
      if (!phone) {
        this.$message.error("请输入手机号");
      } else {
        const reg = new RegExp("^\\d{8,11}$");
        if (!reg.test(phone)) {
          this.$message.error("请输入正确手机号");
        } else {
          this.$captcha.show();
          this.$bus.$on('getTicket', res => {
            if (res.ret === 0) {
              this.$ajax({
                url: this.$url.api + "/api/account/company/register/vcode",
                method: "post",
                params: {
                  mobile: phone,
                  countryCode: this.signin.countryCode.replace('+', ''),
                  ticket: res.ticket,
                  appId: res.appid,
                  randstr: res.randstr
                }
              }).then(res => {
                if (!res.data.success) {
                  this.$message.error(res.data.message);
                } else {
                  this.signupCodeSend = true;
                  this.$message.success("发送成功");
                  this.lockBtn("signupVcodeBtn");
                }
              });
            } else {
              this.$message.error('未通过验证');
            }
            this.$bus.$off('getTicket')
          })
        }
      }
    },
    /**
     * 注册
     */
    onSignup() {
      if (!this.signup.companyName) {
        this.$message.error("请输入公司全称");
      } else if (!this.signup.userName && (!this.$refs.name || !this.$refs.name.value)) {
        this.$message.error("请输入您的姓名");
      } else if (!this.signup.mobile && (!this.$refs.phone || !this.$refs.phone.value)) {
        this.$message.error("请输入您的手机号");
      } else if (!this.signup.validCode) {
        this.$message.error("请输入验证码");
      } else if (!this.signup.businessCode) {
        this.area == 10 && this.$message.error("请输入有效的公司名称") 
      } else {
        this.$store.state.isloading = true;
        this.$ajax({
          url: this.$url.api + "/api/account/company/register/v2",
          method: "post",
          data: {
            companyName: this.signup.companyName,
            businessCode: this.signup.businessCode,
            userName: this.signup.userName || this.$refs.name.value,
            mobile: this.signup.mobile || this.$refs.phone.value,
            countryCode: this.signin.countryCode.replace('+', ''),
            validCode: this.signup.validCode,
            appId: this.kindActive + "-app",
            inviteCode: this.signup.inviteCode,
            areaCategory: this.area
          }
        }).then(res => {
          this.$store.state.isloading = false;
          if (res.data.success) {
            this.redirectApp(res.data.data);
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
    lockBtn(ref) {
      let dom = this.$refs[ref],
        text = dom.innerText;
      dom.timer = 60;
      dom.disabled = "disabled";
      const interval = setInterval(() => {
        dom.innerText = dom.timer;
        dom.timer--;
        if (dom.timer < 0) {
          clearInterval(interval);
          dom.innerText = text;
          dom.disabled = "";
        }
      }, 1000);
    },
    getPartnerInfo(inviteCode) {
      const me = this;
      me.$ajax({
        url: me.$url.api + "/api/account/partner/read",
        params: {
          inviteCode
        }
      }).then(res => {
        let resp = res.data, data = resp.data;
        if (resp.success) {
          if (data && data.name) {
            me.signup.inviteCode = inviteCode;
            me.partner = data;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    /**
     * 企业名模糊查询选择
     */
    onCompanySelect(company) {
      var code = company.creditCode;
      if (!code || !code.length) {
        code = company.no;
      }
      this.signup.businessCode = code;
    }
  }
};
</script>

<style>
.shut {
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
}
.area-box .area-item {
  background: #f8f8f8;
}
</style>



// WEBPACK FOOTER //
// src/components/conenter/loginbox.vue